import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import { firebaseConnect, dataToJS } from 'react-redux-firebase';

import Dropzone from 'react-dropzone';
import TrashIcon from 'assets/icons/trash';
import DownloadIcon from 'assets/icons/download';
import Button from 'components/Button';
import InlineSVG from 'svg-inline-react';
import Input from 'components/Input';


import './supplementalmaterials.scss';
import { formatValue } from '../../util';

class SupplementalMaterialsItem extends Component {


    constructor (props) {
        super(props);

        this.state = {
            name: this.props.file ? this.props.file.name : '',
            file: this.props.file
        };
    }

    onFileDrop (files) {
        const { firebase } = this.props;
        let filesPath = `/files/supplemental_materials/${this.props.product.productId}/`;
        let materialsPath = `/products/${this.props.product.id}/materials/`;
        firebase.uploadFile(filesPath, files[0], materialsPath).then( (response)=> {
            this.props.updateFilesList(response.key, response.File);
        });
    }

	deleteFile (file, fileId) {
		const { firebase } = this.props;
		firebase.deleteFile(file.fullPath).then( (response)=> {
		    firebase.remove(`/products/${this.props.product.id}/materials/${this.props.file.id}`)
			this.props.deleteFile(this.props.file.id);
		});
	}

    updateFilename (event) {
        let value = formatValue(event.target.value, event.target.type);
        const { firebase } = this.props;
        firebase.set(`/products/${this.props.product.id}/materials/${this.props.file.id}/name`, value);
        this.setState({
            name: value,
            file: this.props.file
        });
    }

	render () {
		let canDelete = this.props.canDelete;
		let canEdit = this.props.canEdit;
		let file = this.props.file;

		return (
		    <div>
                {file ?
                    (
                        <div className="supplemental-material-item">
                            <a target="_blank"
                                href={file.downloadURL}
                            >
                                <span className="button download-file">
                                    <InlineSVG src={DownloadIcon} element="span" className="icon" />
                                </span>
                            </a>
                            <span>&nbsp;</span>
                            {canDelete && (
                                <span>
                                    <Button
                                        icon={TrashIcon}
                                        buttonClass="delete-file"
                                        onClick={this.deleteFile.bind(this, file)}
                                    />
                                </span>
                            )}
                            {canEdit  ?
                                (
                                    <Input
                                        placeholder="Name"
                                        type="text"
                                        name="Name"
                                        inputClass="filename"
                                        value={this.state.name}
                                        onChange={this.updateFilename.bind(this)}
                                    />
                                )
                                :
                                (
                                    <span className="filename">{this.state.name}</span>
                                )
                            }
                        </div>
                    )
                    :
                    (
                        <Dropzone
                            multiple={false}
                            accept="application/pdf, application/zip,application/octet-stream"
                            className="empty-area"
                            onDrop={this.onFileDrop.bind(this)}
                        >
                            <div className="label">
                                <div className="text">
                                    Drag and drop file here
                                    or click to select
                                </div>
                            </div>
                        </Dropzone>
                    )
                }

            </div>
		);
	}
}


const fbWrappedComponent = firebaseConnect()(SupplementalMaterialsItem);

export default connect()(fbWrappedComponent);



// WEBPACK FOOTER //
// ./js/components/SupplementalMaterials/SupplementalMaterialsItem.js